import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, finalize, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { isFxRatesHttpUrl } from './keycloak-http.config';
import { SpinnerService } from './services/spinner.service';

/**
 * Spinner global com atraso: pedidos rápidos não abrem overlay (UX “invisível”).
 * `environment.httpSpinnerDelayMs === 0` restaura o comportamento imediato (legado).
 */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const spinner = inject(SpinnerService);

  const isFxRates = isFxRatesHttpUrl(req.url);
  const delayMs = environment.httpSpinnerDelayMs ?? 0;

  const run = () =>
    next(req).pipe(
      catchError((err: HttpErrorResponse) => {
        const errorObj = {
          success: false,
          message: err.message,
          status: err.status,
          error: err.error,
          url: err.url,
        };

        return throwError(() => errorObj);
      })
    );

  if (isFxRates) {
    return run();
  }

  if (delayMs <= 0) {
    spinner.show();
    return run().pipe(
      finalize(() => {
        spinner.hide();
      })
    );
  }

  let spinnerActivated = false;
  const timerId = window.setTimeout(() => {
    spinnerActivated = true;
    spinner.show();
  }, delayMs);

  return run().pipe(
    finalize(() => {
      window.clearTimeout(timerId);
      if (spinnerActivated) {
        spinner.hide();
      }
    })
  );
};
